var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"step-indicator"},_vm._l((_vm.steps),function(n){return _c('li',{key:n,staticClass:"step-item"},[_c('button',{staticClass:"step-btn",class:{ active: _vm.currentStep === n },style:({
        borderColor: _vm.color,
        backgroundColor: _vm.currentStep === n ? _vm.color : 'transparent',
      }),attrs:{"title":("Go to step " + n)},on:{"click":function($event){return _vm.$emit('stepClick', n)}}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }